import orthoticStylesArray from './store/Products';

export function joinPath(basePath, path) {
	return new URL(path, basePath).href;
}

export function compareSavedRxes(prescription1, prescription2) {
	let has1 = orthoticStylesArray.includes(prescription1.fileName);
	let has2 = orthoticStylesArray.includes(prescription2.fileName);

	if (!has1 && !has2) {
		return 0;
	} else if (has1 && !has2) {
		return -1;
	} else if (!has1 && has2) {
		return 1;
	} else {
		//both names are registered
		let index1 = orthoticStylesArray.indexOf(prescription1.fileName);
		let index2 = orthoticStylesArray.indexOf(prescription2.fileName);
		return index1 - index2 < 0 ? -1 : 1;
	}
}

export function orthoticStyleToTitle(orthoticStyle: string) {
	switch (orthoticStyle) {
		case 'standard':
			return 'Functional Orthotic';
		case 'stability':
			return 'Stability Orthotic';
		case 'comfort':
			return 'Everyday Comfort';
		case 'sports':
			return 'Sports Orthotic';
		case 'dress':
			return 'Dress/Low Profile';
		default:
			return orthoticStyle;
	}
}

export function orthoticStyleToImagePath(orthoticStyle) {
	switch (orthoticStyle) {
		case 'standard':
			return require('@/assets/order-styles/orthotic-functional.png');
		case 'stability':
			return require('@/assets/order-styles/orthotic-stability.png');
		case 'comfort':
			return require('@/assets/order-styles/orthotic-comfort.png');
		case 'sports':
			return require('@/assets/order-styles/orthotic-athletic.png');
		case 'dress':
			return require('@/assets/order-styles/orthotic-dress.png');
	}
}
